import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAuctionDetails } from '../../../store/auction-detail/action';
import { submitPlaceBid } from '../../../store/auctions/action';
import { setupToast } from '../../../store/toast/action';
import AuctionDetail from './component';
import { setActiveSlideIndex } from '../../../store/auction-detail/action';

const mapStateToProps = ({ auctionDetail, user }) => ({
    auctionDetail, user
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getAuctionDetailsConnect: getAuctionDetails,
    submitPlaceBidConnect: submitPlaceBid,
    setActiveSlideIndexConnect: setActiveSlideIndex,
    setupToastConnect: setupToast
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AuctionDetail);